
export interface Branding {
  productName: string;
  logoLight: string;
  logoDark: string;
  faviconUrl: string | null;
  primaryColor: string | null;
  accentColor: string | null;
  supportEmail: string;
  isPartnerBranded: boolean;
  ogImageUrl: string | null;
  ogTitle: string | null;
  ogDescription: string | null;
}

const WDC_DEFAULT: Branding = {
  productName: "WDC Today",
  logoLight: "/logo.png",
  logoDark: "/logo.png",
  faviconUrl: null,
  primaryColor: null,
  accentColor: null,
  supportEmail: "wecare@wdcweb.com",
  isPartnerBranded: false,
  ogImageUrl: null,
  ogTitle: null,
  ogDescription: null,
};

/** Always WDC branding (white-label partners were removed). */
export const useBranding = (): Branding => WDC_DEFAULT;
